{
  "it": {
    "issue_list": {
      "actions": {
        "add_units": "Unità",
        "all_units_assigned": "Tutte le unità assegnate",
        "change_responsible": "Cambia responsabile",
        "check": "Verifica",
        "create_issue_lists": "Crea elenco segnalazioni | Crea elenchi segnalazioni",
        "delete": "Elimina",
        "delete_count": "Sta per eliminare le segnalazioni di {count} unità. È sicuro? | Sta per eliminare le segnalazioni di {count} unità. È sicuro?",
        "delete_issue_lists": "Elimina segnalazioni",
        "edit": "Modifica",
        "edit_issue_list": "Modifica tipo di elenco segnalazioni",
        "export": "Esporta",
        "generatePDF": "Genera PDF",
        "go_to_summary": "Vai al riepilogo",
        "new": "Segnalazione",
        "new_customer": "Invia segnalazione",
        "new_issue_list": "Elenco segnalazioni",
        "selectAll": "Seleziona tutti i {total} elenchi",
        "unSelectAll": "Svuota selezione",
        "update": "Aggiorna"
      },
      "attributes": {
        "date": "Data di inizio",
        "description": "Descrizione",
        "name": "Nome"
      },
      "labels": {
        "aftercare_conversations": "Conversazioni post-vendita",
        "aftercare_conversations_go_to_settings": "Vai alle impostazioni",
        "aftercare_conversations_not_enabled": "Le conversazioni nel post-vendita non sono ancora attive. Può attivarle nelle impostazioni della Sua organizzazione.",
        "aftercare_conversations_toggle": "Attiva le conversazioni nel post-vendita",
        "assign_to_list": "Assegna all'elenco",
        "collapse_all": "Comprimi",
        "completed_header": "{completed_count} segnalazioni completate su {issues_count}",
        "customer": "Cliente",
        "date": "Data di inizio (facoltativa)",
        "delete_explanation": "Tutte le segnalazioni, insieme a immagini e documenti, verranno eliminate definitivamente dalla piattaforma.",
        "description_title": "Aggiunga una descrizione",
        "deselect_all": "Deseleziona tutto",
        "edit_multiple": "Modifica {count} elenchi segnalazioni",
        "hide_count": "Annulla pubblicazione segnalazioni per 1 unità | Annulla pubblicazione segnalazioni per {count} unità",
        "hide_count_SUP": "Annulla pubblicazione segnalazioni",
        "issue_list": "Elenco segnalazioni",
        "issue_lists": "Post-vendita",
        "issue_lists_all_projects": "Post-vendita di tutti i progetti",
        "issues_count": "Segnalazioni",
        "no_issues_to_export": "Nessuna segnalazione da esportare",
        "no_lists_completed": "Nessun elenco completato",
        "open_all": "Apri",
        "partners": "Partner",
        "pdf_generated_successfully": "PDF generato con successo",
        "process_issues": "Assegna all'elenco",
        "project_units_total": "{project_name} ha {units_count_max} unità in totale",
        "publish_now": "Pubblicare ora?",
        "published_count": "Pubblica segnalazioni per 1 unità | Pubblica segnalazioni per {count} unità",
        "published_count_SUP": "Pubblica segnalazioni",
        "save_explainer": "Rendere visibili le (future) segnalazioni ai Suoi clienti? Oppure salvare e pubblicare più avanti?",
        "selectOne": "Seleziona almeno 1 elenco",
        "select_all": "Seleziona tutto",
        "selected": "{selected} elenco selezionato. | {selected} elenchi selezionati",
        "status": "stato",
        "step_1_info": "Es. consegna preliminare o finale, segnalazioni per cucina o bagni,...",
        "step_1_title": "Che tipo di elenco segnalazioni desidera creare?",
        "step_2_subtitle": "Selezioni il progetto per includere subito tutte le Sue unità. Potrà sempre aggiungerne altre in seguito.",
        "step_2_title": "Per quali unità desidera registrare segnalazioni?",
        "tab_issue_list_documents": "Documenti",
        "tab_issue_list_issues": "Segnalazioni",
        "tab_issue_list_issues_customer": "Post-vendita",
        "tab_issue_list_tickets": "Conversazioni",
        "tab_issues": "Tutte le segnalazioni",
        "tab_units": "Unità",
        "totalSelected": "Tutti i {total} elenchi sono selezionati",
        "you_have_customer_issues": "Ha 1 segnalazione cliente non elaborata | Ha {number} segnalazioni cliente non elaborate"
      },
      "navigation": {
        "back_to_issue_lists": "Torna agli elenchi segnalazioni"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Segua l'andamento delle segnalazioni inviate",
            "title": "Tutte le Sue segnalazioni verranno mostrate qui"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Crei segnalazioni per le unità collegate all'elenco",
            "title": "Crei il Suo primo elenco di segnalazioni"
          }
        },
        "partners": {
          "subtitle": "Sarà avvisato quando verranno create nuove segnalazioni",
          "title": "Nessuna segnalazione le è ancora stata assegnata"
        }
      },
      "validation": {
        "name_taken_locale": "Questo nome è già in uso in questa lingua",
        "need_name": "Il nome è obbligatorio"
      }
    }
  }
}
